<template>
  <main>
    <PageHeader :content="headerTitleOnly ?? null" />
    <PageSections :sections="sections" />
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {PageHeader, PageSections} from '@/components/sections'
import {usePageStore} from '@/stores'

export default {
  name: 'PoliciesPage',
  mixins: [ViewDataMixin],
  components: {PageHeader, PageSections},
  data() {
    return {
      page: null as Page | null,
    }
  },
  computed: {
    sections() {
      return this.page?.data.header
        ? [
            {
              background: 'white' as background,
              content: this.page.data.header.description,
              title: null,
              flexKey: 'rich-text-section',
              flexLayout: 'rich-text-section' as sectionType,
            },
          ]
        : ([
            {
              background: 'white' as background,
              content: this.$t('policies.content'),
              title: this.$t('policies.title'),
              flexKey: 'rich-text-section',
              flexLayout: 'rich-text-section' as sectionType,
            },
          ] as RepeatableSection[])
    },
    headerTitleOnly() {
      return {title: this.page?.data.header.title ?? ''} as PageHeader
    },
  },
  methods: {
    async init() {
      const page = await usePageStore().get('policies')

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
    },
  },
}
</script>
